
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { User } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Child } from '@/types/child';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { logger } from '@/utils/logger';

interface ChildCardProps {
  child: Child;
}

const ChildCard: React.FC<ChildCardProps> = ({ child }) => {
  logger.log('Rendering ChildCard with data:', child);
  
  // Format date correctly accounting for timezone offset
  const formatBirthdate = (dateString: string) => {
    if (!dateString) return 'Unknown';
    
    try {
      // Create date object and adjust for local timezone
      const date = new Date(dateString);
      // Add the timezone offset to get the correct date
      const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
      return utcDate.toLocaleDateString();
    } catch (e) {
      logger.error('Error formatting date:', e);
      return 'Unknown';
    }
  };
  
  return (
    <Card key={child.id} className="overflow-hidden hover:shadow-md transition-shadow">
      <Link to={`/children/${child.id}`}>
        <div className="h-48 overflow-hidden bg-gray-200 flex items-center justify-center">
          {child.photoUrl ? (
            <Avatar className="w-full h-full rounded-none">
              <AvatarImage 
                src={child.photoUrl} 
                alt={child.name} 
                className="object-cover w-full h-full"
              />
              <AvatarFallback className="w-full h-full rounded-none">
                <User className="h-16 w-16 text-gray-400" />
              </AvatarFallback>
            </Avatar>
          ) : (
            <User className="h-16 w-16 text-gray-400" />
          )}
        </div>
        <CardHeader>
          <CardTitle>{child.name}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-gray-500">
            Birthday: {formatBirthdate(child.birthdate)}
          </p>
          <div className="mt-4 flex justify-center">
            <Button variant="outline" size="sm">View Profile</Button>
          </div>
        </CardContent>
      </Link>
    </Card>
  );
};

export default ChildCard;
